import { render, staticRenderFns } from "./auctionPackageCreativeFormatForm.vue?vue&type=template&id=60bf436b&lang=pug"
import script from "./auctionPackageCreativeFormatForm.vue?vue&type=script&lang=js"
export * from "./auctionPackageCreativeFormatForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports